import image1 from '../assets/sliderImg1.webp';
import image2 from '../assets/sliderImg2.webp';
import image3 from '../assets/sliderImg3.webp';
import image4 from '../assets/sliderImg4.webp';
import image5 from '../assets/sliderImg5.webp';
import image6 from '../assets/sliderImg6.webp';
import image7 from '../assets/sliderImg7.webp';
import image8 from '../assets/sliderImg8.webp';
import image9 from '../assets/sliderImg9.webp';
import image10 from '../assets/sliderImg10.webp';

const galleryImages = [
    {
        image: image1,
        title: 'Little one baby spa photo'
    },
    {
        image: image2,
        title: 'Little one baby spa photo'
    },
    {
        image: image3,
        title: 'Little one baby spa photo'
    },
    {
        image: image4,
        title: 'Little one baby spa photo'
    },
    {
        image: image5,
        title: 'Little one baby spa photo'
    },
    {
        image: image6,
        title: 'Little one baby spa photo'
    },
    {
        image: image7,
        title: 'Little one baby spa photo'
    },
    {
        image: image8,
        title: 'Little one baby spa photo'
    },
    {
        image: image9,
        title: 'Little one baby spa photo'
    },
    {
        image: image10,
        title: 'Little one baby spa photo'
    },
];

export default galleryImages;